import { Component } from '@angular/core';

@Component({
  selector: 'app-info-component',
  imports: [],
  templateUrl: './info-component.html',
  styleUrl: './info-component.scss'
})
export class InfoComponent {

}
